import React, { useEffect, useState } from 'react'
import { Container, Row, Col, Button, Form, Card } from 'react-bootstrap'
import { useDispatch, useSelector } from "react-redux"
import { useTranslation } from "react-i18next"
import { useAuth } from "../../components/auth/useAuth"
import { Link, useNavigate } from 'react-router-dom'
// import ChangeLanguage from '../../translations/ChangeLanguage'
import Version from '../../version'
import { useMsal } from "@azure/msal-react";
import { microsoftLogin } from '../../actions/usersActions'
import { jwtDecode } from 'jwt-decode'

const clientCredentials = {}

export default function Login() {
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const [islogging, setIslogging] = useState(false)
    const [isCorrect, setIsCorrect] = useState(true)
    const {loginClient, clientauth} = useAuth()
    const navigate = useNavigate()

    const [showPasswordOne, setShowPasswordOne] = useState(false)
    const { instance } = useMsal()

    const { jwtChange } = useSelector(state => state.users)

    useEffect(() => {
        const jwt = localStorage.getItem("jwt")
        const decoded = jwt ? jwtDecode(jwt) : null

        if (jwt && decoded && decoded?.rol) {
            switch (decoded?.rol) {
                case "admin":
                    navigate("/admin/dashboard")
                    break
                case "employee":
                    navigate("/empleado/dashboard")
                    break
                default:
                    navigate("/")
                    break
            }
        }
    }, [clientauth, instance, navigate, jwtChange])

    const handleLogin = async () => {
        try {
            await instance.loginRedirect({
                scopes: ["openid", "profile", "email"]
            })
        } catch (error) {
            console.error(error)
        }
    }

    const handlePasswordVisibilityOne = () => {
        setShowPasswordOne(!showPasswordOne)
    }

    const handleSubmit = async(e) => {
        e.preventDefault()
        setIslogging(true)
        loginClient(clientCredentials).then(() => {
            setIsCorrect(false)
            setIslogging(false)
        })
    }

    return (
        <>
            <Container fluid className='vh-100'>
                <Row className='h-100'>
                    <Col md={6} className='d-none d-md-flex login-fondo flex-column justify-content-center'>
                        <Row>
                            <Col className='d-flex align-items-start text-white'>
                                <div>
                                    <img src="/images/logotipo-blanco.svg" alt="logotipo" width={160}/>
                                </div>
                                <div className='mt-2'>
                                    <div className='fs-1 fw-light mb-0 text-white mb-1'>SILBON</div>
                                    <p className='fw-light'>{t('signin.claim')}</p>
                                </div>
                            </Col>
                        </Row>
                        <Row className='mx-4 mb-5'>
                            <Col>
                                <h2 className='fw-bolder text-white'>{t('signin.welcome')}</h2>
                                <p className='fw-light text-white'>{t('signin.frase')}</p>
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={12} md={6} className='d-flex flex-column justify-content-center px-5'>
                        <Container>
                            <Row>
                                <Col>
                                    <h2 className='fw-bold text-black mb-5'>{t('signin.login')}</h2>
                                    <p>{t('signin.loginDescription')}</p>
                                </Col>
                            </Row>
                            <Row>
                                <Col className='text-center'>
                                    <button className='btn btn-outline-primary w-100' onClick={handleLogin}>
                                        {t('signin.loginSSO')}
                                    </button>
                                </Col>
                            </Row>
                            <Row>
                                <Col className='text-center text-uppercase my-3'>
                                    {t('signin.continueEmail')}
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Form className="formulario" onSubmit={ handleSubmit}>
                                        <Row className="my-3">
                                            <Col>
                                                <Form.Label className="form-label fw-bold">{t('signin.email')}</Form.Label>
                                                <Form.Control
                                                    placeholder={t('signin.emailplace')}
                                                    name="login_email"
                                                    className={isCorrect ? "input-login" : "input-login invalid"}
                                                    type="text"
                                                    autoComplete="off"
                                                    onChange={ (e) => clientCredentials.email = e.target.value}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="my-3 ">
                                            <Col className='row-eye'>
                                                <Form.Label className="form-label fw-bold">{t('signin.password')}</Form.Label>
                                                <Form.Control
                                                    placeholder={t('signin.passwordplace')}
                                                    name="login_password"
                                                    className={isCorrect ? "input-login" : "input-login invalid"}
                                                    type={showPasswordOne ? 'text' : 'password'}
                                                    autoComplete="off"
                                                    onChange={ (e) => clientCredentials.password = e.target.value}
                                                />
                                                <img className="sd-imageneye" src={showPasswordOne ? "../images/eyeclose.svg" : "../images/eyeopen.svg"} alt="eyes" width={15} onClick={handlePasswordVisibilityOne}></img>
                                            </Col>
                                        </Row>
                                        {!isCorrect
                                            ?
                                                <>
                                                    <span>{t('signin.loginwrong')}</span>
                                                </>
                                            :
                                                <></>
                                        }
                                        <Row>
                                            <Col className="justify-content-center text-end">
                                                <Link to="/forgotpassword" className="link">{t('signin.passwordforgoten')}</Link>
                                            </Col>
                                        </Row>
                                        <Row className="text-center my-3">
                                            <Col>
                                                <Button variant='primary' type="submit" className="w-100 my-2">
                                                {islogging
                                                    ?
                                                        <>
                                                            <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                                        </>
                                                    :
                                                        <>{t('signin.login')}</>
                                                }
                                                </Button>
                                            </Col>
                                        </Row>
                                    </Form>
                                </Col>
                            </Row>
                            <Row className='mt-4'>
                                <Col className="justify-content-center text-center">
                                    {t('signin.needHelp')}<br/>
                                    <a href="mailto:soporte@silbon.com" className="link">soporte@silbon.com</a>
                                </Col>
                            </Row>
                            <Row>
                                <Col className='text-center my-3'>
                                    <Version />
                                </Col>
                            </Row>
                        </Container>

                    </Col>
                </Row>
            </Container>
        </>
    )
}
